import { ProductionZoneCreationForm } from "../create/schema/production-zone-creation.schema";

export const hasEmptyProductionZoneFormValues = (
  values: Partial<ProductionZoneCreationForm> | undefined,
  requireActivo = false,
) => {
  const nombre = String(values?.nombre ?? "").trim();
  const zonaComercial = Array.isArray(values?.zonaComercial)
    ? values?.zonaComercial?.[0]
    : values?.zonaComercial;
  const activo = Array.isArray(values?.activo)
    ? values?.activo?.[0]
    : values?.activo;

  return (
    !nombre ||
    !String(zonaComercial ?? "").trim() ||
    (requireActivo && typeof activo !== "boolean")
  );
};
